import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";

import Layout from "../../components/Layout";
import InfoFooter from "../../components/InfoFooter";
import ReservioButton from "../../components/ReservioButton";
import { EMAILJS, SHOP } from "../../config";

import storeImage from "../../img/optika-zvenku.jpg";
import phoneIcon from "../../img/phone-icon.svg";
import mailIcon from "../../img/mail-icon.svg";
import locationIcon from "../../img/location-icon.svg";
import timeIcon from "../../img/time-icon.svg";
import vizitka from "../../img/vizitka.png";
import downloadIcon from "../../img/download.svg";

const openingHours = [
  ["pondělí:", "8:30–11:30, 12:30–16:00"],
  ["úterý:", "8:30–11:30, 12:30–16:00"],
  ["středa:", "8:30–11:30, 12:30–17:00"],
  ["čtvrtek:", "12:30–17:00"],
  ["pátek:", "8:30–11:30, 12:30–15:00"],
  ["sobota:", "Po telefonické dohodě"],
  ["neděle:", "Zavřeno"],
];

const NAME_PATTERN = /^\W*([A-ZĚŠČŘŽÝÁÍÉa-zěščřžýáíé]+(\W+|$)){1,4}$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

const Kontakt = () => {
  const formRef = useRef(null);

  // The Gatsby version validated by writing straight into the DOM. Same
  // rules, but the messages are state now.
  const [errors, setErrors] = useState({ name: "", email: "" });
  const [status, setStatus] = useState("");

  const sendEmail = (event) => {
    event.preventDefault();

    const form = event.target;
    const name = form.name.value;
    const email = form.email.value;

    const nextErrors = {
      name: NAME_PATTERN.test(name)
        ? ""
        : "Zadejte jméno a příjmení (max 4 slova)",
      email: EMAIL_PATTERN.test(email) ? "" : "Prosím zadejte platný email",
    };

    setErrors(nextErrors);
    if (nextErrors.name || nextErrors.email) return;

    if (!EMAILJS.serviceId || !EMAILJS.templateId || !EMAILJS.publicKey) {
      setStatus("Formulář zatím není nastaven. Napište nám prosím e-mailem.");
      return;
    }

    setStatus("Odesílám…");

    emailjs
      .sendForm(EMAILJS.serviceId, EMAILJS.templateId, form, {
        publicKey: EMAILJS.publicKey,
      })
      .then(
        () => {
          setStatus("Email byl úspěšně odeslán");
          form.reset();
          setTimeout(() => setStatus(""), 5000);
        },
        () => {
          setStatus("Email se nepodařilo odeslat. Zkuste to prosím později.");
        }
      );
  };

  return (
    <Layout>
      <Helmet
        title="Kontakty | Optika Volyně"
        meta={[
          {
            name: "description",
            content:
              "Kontakty a adresa prodejny optiky a optometrických služeb ve Volyni",
          },
          {
            name: "keywords",
            content: "Optika, Optometrie, Volyně, Brýle, Kontakt",
          },
        ]}
      />
      <main className="contact-main">
        <div className="contact-first">
          <div className="basic-contacts-container">
            <div className="store-image-container">
              <img
                className="store-image"
                src={storeImage}
                alt="obrázek provozovny Optika Volyně"
              />
              <div className="contact-heading">
                <p>Kontakty</p>
              </div>
            </div>

            <div className="basic-contacts-data">
              <div className="basic-contacts">
                <div className="basic-contact-container">
                  <div>
                    <img src={phoneIcon} alt="phone-icon" />
                  </div>
                  <div className="basic-contact">
                    <h2>Zavolejte nám</h2>
                    <a href={`tel:${SHOP.phone}`}>{SHOP.phone}</a>
                  </div>
                </div>
                <div className="basic-contact-container">
                  <div>
                    <img src={mailIcon} alt="mail-icon" />
                  </div>
                  <div className="basic-contact">
                    <h2>Napište nám</h2>
                    <a href={`mailto:${SHOP.email}`}>{SHOP.email}</a>
                  </div>
                </div>
                <div className="basic-contact-container">
                  <div>
                    <img src={locationIcon} alt="location-icon" />
                  </div>
                  <div className="basic-contact">
                    <h2>Adresa</h2>
                    <p>náměstí Svobody 14, Volyně, 387&nbsp;01</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="basic-contacts-data open-time">
              <div className="basic-contact-container">
                <div>
                  <img src={timeIcon} alt="time-icon" />
                </div>
                <div className="basic-contact">
                  <h2>Otevírací doba</h2>
                  {openingHours.map(([day, hours]) => (
                    <div className="day" key={day}>
                      <p>{day}</p>
                      <p>{hours}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ReservioButton />

        <section className="get-there">
          <div className="get-there-desc-container">
            <div className="get-there-desc">
              <h2>Jak se k nám dostat?</h2>
              <ul>
                <li>
                  <strong style={{ color: "#77A02E" }}>Pěšky:</strong> Nacházíme
                  se ve Volyni přímo na náměstí
                </li>
                <li>
                  <strong style={{ color: "#77A02E" }}>Autem:</strong> Před
                  optikou je možné zaparkovat. GPS souřadnice jsou: E13.8851194,
                  N49.1658592
                </li>
                <li>
                  <strong style={{ color: "#77A02E" }}>Autobusem:</strong> 50
                  metrů od optiky je volyňská autobusová zastávka, kde staví
                  lokální i dálkové spoje
                </li>
              </ul>
            </div>
          </div>
          <div className="mapa">
            <iframe
              className="mapa-iframe"
              title="Mapa - Optika Volyně"
              width="640"
              height="420"
              loading="lazy"
              src={`https://mapy.com/cs/zakladni?x=13.8851166667&y=49.1658611111&z=17&source=firm&id=${SHOP.mapyBadgeId}&widgetFirmy=${SHOP.mapyBadgeId}&frame=1`}
              frameBorder="0"
            />
          </div>
        </section>

        <div className="business-card">
          <p>Naše vizitka ke stažení</p>
          <a href={vizitka} download>
            <img
              className="business-card-itself"
              alt="vizitka ke stažení"
              src={vizitka}
            />
            <img
              className="download-icon"
              alt="download-icon"
              src={downloadIcon}
            />
          </a>
        </div>

        <div className="contact-second">
          <div className="form-and-location">
            <div className="contact-form">
              <h2>Kontaktujte nás</h2>
              <form ref={formRef} onSubmit={sendEmail}>
                <div className="user-data">
                  <div className="user-data-entity">
                    <label htmlFor="contact-name">Celé jméno</label>
                    <input
                      id="contact-name"
                      type="text"
                      className="name-input"
                      name="name"
                      placeholder="Jméno a příjmení"
                    />
                  </div>
                  <div className="user-data-entity">
                    <label htmlFor="contact-email">Email</label>
                    <input
                      id="contact-email"
                      type="text"
                      className="email-input"
                      name="email"
                      placeholder="Vaše emailová adresa"
                    />
                  </div>
                </div>
                <div className="message">
                  <label htmlFor="contact-message">Zpráva</label>
                  <textarea
                    id="contact-message"
                    name="zprava"
                    placeholder="Napište nám zprávu"
                    defaultValue=""
                  />
                </div>
                <div className="send">
                  <input
                    className="button"
                    type="submit"
                    name="submit"
                    value="Odeslat"
                  />
                  {errors.name && <p className="alert-name">{errors.name}</p>}
                  {errors.email && (
                    <p className="alert-email">{errors.email}</p>
                  )}
                  {status && <p className="alert-success">{status}</p>}
                </div>
              </form>
            </div>

            <div className="location">
              <div className="tax-data">
                <h2>Fakturační údaje</h2>
                <p>{SHOP.owner}</p>
                <p>
                  Na Ostrovci 25
                  <br />
                  Volyně, 387 01
                  <br />
                  IČ: {SHOP.ico}
                  <br />
                  DIČ: CZ7561022326
                </p>
                <p>
                  Úřad příslušný podle §71 odst.2 živnostenského zákona: Městský
                  úřad Strakonice
                </p>
              </div>
            </div>
          </div>
        </div>

        <InfoFooter />
      </main>
    </Layout>
  );
};

export default Kontakt;
